import { PostHogEvents, useTrackEvent } from "@/lib/posthog-events";
import type { UserRecordSurface } from "./user-record-tabs";

export function useRecordSaveTracker(
  surface: UserRecordSurface,
  userName: string,
) {
  const { track } = useTrackEvent();

  return (field: string) => {
    if (surface === "self") {
      track(PostHogEvents.SELF_RECORD_SAVED, { field_changed: field });
      return;
    }

    track(PostHogEvents.USER_RECORD_SAVED, {
      field_changed: field,
      user_name: userName,
    });
  };
}
